import { IP } from '../configuracion.js';

const enviar_pedidokds = async (pedidoData, mostrarMensaje, property) => {
  // AbortController: si el servidor no responde en 10s, la request falla limpiamente
  // en lugar de quedarse colgada bloqueando la cola de producción
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    if (!property) {
      throw new Error("Propiedad no definida");
    }

    const url = `${IP}/tavpos/backend/outpedidos.php?property=${encodeURIComponent(property)}`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(pedidoData),
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`Error HTTP ${response.status}`);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message || "No se actualizó correctamente.");
    }

    if (mostrarMensaje && typeof mostrarMensaje === 'function') {
      mostrarMensaje(result.message || "Ítem actualizado correctamente.");
    }

    return result;
  } catch (error) {
    // AbortError = timeout de 10s — registrar como advertencia, no error crítico
    if (error.name === 'AbortError') {
      console.warn("enviar_pedidokds: timeout (10s) — servidor sin respuesta");
    } else {
      console.error("Error en enviar_pedidokds:", error);
    }
    if (mostrarMensaje && typeof mostrarMensaje === 'function') {
      mostrarMensaje(`Error: ${error.message}`);
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

export default enviar_pedidokds;